export const language = {
  zh: {
    'Delivery address': '收货地址',
    'Add address': '新增地址',
  },
  en: {
    'Delivery address': 'Delivery address',
    'Add address': 'Add address',
  }
};
